import { render, staticRenderFns } from "./exchangeCharts.vue?vue&type=template&id=3cd432a8"
import script from "./exchangeCharts.vue?vue&type=script&lang=js"
export * from "./exchangeCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd432a8')) {
      api.createRecord('3cd432a8', component.options)
    } else {
      api.reload('3cd432a8', component.options)
    }
    module.hot.accept("./exchangeCharts.vue?vue&type=template&id=3cd432a8", function () {
      api.rerender('3cd432a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/exchangeCharts.vue"
export default component.exports